import PolicyHint from './PolicyHint';

export default function PolicyField({
  label,
  value,
  onChange,

  locked = false,
  reason = '',

  proposalMode = false,
  proposalValue = '',
  onProposalChange,
  onLoginRequired,

  type = 'text',
  multiline = false,
  placeholder = '',
  rows = 4,
  children,
}) {
  const isProposalActive = locked && proposalMode;
  const isReadOnlyLocked = locked && !proposalMode;

  const displayValue = isProposalActive
    ? proposalValue ?? ''
    : value ?? '';

  const handleChange = (newValue) => {
    if (isProposalActive) {
      onProposalChange?.(newValue);
      return;
    }

    if (!isReadOnlyLocked) {
      onChange?.(newValue);
    }
  };

  const handleLockedInteraction = () => {
    if (isReadOnlyLocked) {
      onLoginRequired?.();
    }
  };

  const baseInputStyle = {
    width: '100%',
    padding: '8px 10px',
    borderRadius: 10,
    border: locked ? '1px solid #f59e0b' : '1px solid #cbd5e1',
    background: isProposalActive ? '#eff6ff' : locked ? '#fffbeb' : '#ffffff',
    color: isReadOnlyLocked ? '#92400e' : '#0f172a',
    opacity: isReadOnlyLocked ? 0.95 : 1,
    boxSizing: 'border-box',
    cursor: isReadOnlyLocked && onLoginRequired ? 'pointer' : 'text',
  };

  return (
    <div style={{ marginBottom: 14 }}>
      {label && (
        <label
          style={{
            display: 'block',
            fontWeight: 700,
            marginBottom: 6,
            color: '#0f172a',
          }}
        >
          {label}
        </label>
      )}

      {children ? (
        children
      ) : multiline ? (
        <textarea
          value={displayValue}
          onChange={(e) => handleChange(e.target.value)}
          onClick={handleLockedInteraction}
          onFocus={handleLockedInteraction}
          readOnly={isReadOnlyLocked}
          placeholder={placeholder}
          rows={rows}
          style={{
            ...baseInputStyle,
            resize: 'vertical',
            minHeight: 96,
          }}
        />
      ) : (
        <input
          type={type}
          value={displayValue}
          onChange={(e) => handleChange(e.target.value)}
          onClick={handleLockedInteraction}
          onFocus={handleLockedInteraction}
          readOnly={isReadOnlyLocked}
          placeholder={placeholder}
          style={baseInputStyle}
        />
      )}

      <PolicyHint
        locked={locked}
        reason={reason}
        proposalMode={isProposalActive}
      />
    </div>
  );
}
